import { render, staticRenderFns } from "./TransitionHeightWrap.vue?vue&type=template&id=210c23e9&"
import script from "./TransitionHeightWrap.vue?vue&type=script&lang=js&"
export * from "./TransitionHeightWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports